module.exports = __webpack_public_path__ + "static/img/news14.64dae51.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/news14.png
// module id = W2j1
// module chunks = 1